'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'comment-lines';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f4b0';
var svgPathData = 'M256 31.1c-141.4 0-255.1 93.13-255.1 208c0 49.62 21.35 94.98 56.97 130.7c-12.5 50.38-54.27 95.27-54.77 95.77c-2.25 2.25-2.875 5.734-1.5 8.734c1.25 3 4.021 4.766 7.271 4.766c66.25 0 115.1-31.76 140.6-51.39c32.63 12.25 69.02 19.39 107.4 19.39c141.4 0 255.1-93.13 255.1-207.1S397.4 31.1 256 31.1zM264 320h-112C138.8 320 128 309.3 128 296S138.8 272 152 272h112C277.3 272 288 282.8 288 296S277.3 320 264 320zM360 224h-208C138.8 224 128 213.3 128 200S138.8 176 152 176h208C373.3 176 384 186.8 384 200S373.3 224 360 224z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCommentLines = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/pro-solid-svg-icons/faCommentLines.js
// module id = V9+q
// module chunks = 0